import { ConfigurationAssayLaboratoryResponse } from '@/modules/configurationModule/detail/local-assays/assays-laboratory/services/configuration-assay-laboratory/configuration-assay-laboratory.dto'

export interface ConfigurationLocalAssaysAssaysLaboratoryModalState {
    assayLaboratory: Partial<ConfigurationAssayLaboratoryResponse>
}
export const initialConfigurationLocalAssaysAssaysLaboratoryModalState =
    (): ConfigurationLocalAssaysAssaysLaboratoryModalState => ({
        assayLaboratory: {
            active: true
        }
    })
